
export default function urlParams(winLocationSearch: string): HashMap<string> {
  // let urlObj = <any>ioQuery.queryToObject(winLocationSearch.replace(/^\?/, ""));
  let urlObj;
  urlObj = urlObj || {};

  for (const key in urlObj) {
    if (urlObj.hasOwnProperty(key) && typeof urlObj[key] === "string") {
      // strip out some HTML (<,>,%3C,%3E,&lt;,&gt;)
      urlObj[key] = urlObj[key].replace(/(&lt;|&gt;|<|>|%3C|%3E)/g, "");
    }
  }
  return urlObj;
}

export function findEnvironmentByUrl(): "dev" | "qa" | "prod" | null {
  const hostname = window.location.hostname;
  if (hostname.includes("devext.arcgis")) {
    return "dev";
  } else if (hostname.includes("qa.arcgis")) {
    return "qa";
  } else if (!hostname.includes("arcgis")) {
    return "dev" // presumably "localhost", but uses "dev" resources, so return "dev"
  } else if (hostname.includes("arcgis")) {
    return "prod";
  } else {
    return null;
  }
}
